/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { GoogleMapService } from '../services/googleMap.service';
import { Observable } from 'rxjs';
import { LayoutDirective, LayoutAlignDirective } from '@ngbracket/ngx-layout/flex';
import { ShowHideDirective } from '@ngbracket/ngx-layout';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'dash-gis-street-view',
    template: ` <div [fxShow]="shouldDisplay$ | async" class="sv-container mat-elevation-z4" fxLayout="column">
        <div id="pano-handle" fxLayout="row" fxLayoutAlign="end center">
            <button mat-icon-button (click)="hidePano()">
                <mat-icon svgIcon="close" aria-label="Close"></mat-icon>
            </button>
        </div>
        <div id="streetview-pano" #streetViewElement></div>
    </div>`,
    styleUrls: ['./streetViewPano.scss'],
    imports: [
        LayoutDirective,
        ShowHideDirective,
        LayoutAlignDirective,
        MatIconButton,
        MatIcon,
        AsyncPipe,
    ],
})
export class StreetViewPanoComponent implements OnInit {
    @ViewChild('streetViewElement', { read: ElementRef }) public elementRef: ElementRef;

    constructor(private gMapService: GoogleMapService) {}

    ngOnInit(): void {}

    public hidePano() {
        this.gMapService.hideStreetView();
    }

    get shouldDisplay$(): Observable<boolean> {
        return this.gMapService.streetViewPanoVisible$;
    }
}
